export const SPINNING_ICON = '<span class="spinning-icon"></span>';

export function updateDomElements(
  fileSizeText?: string,
  fileNameText?: string,
  uploadText?: string,
  priceText?: string,
  numPagesText?: string
) {
  const $form = document.querySelector("#tw-print-form") as HTMLFormElement;
  const $tracker = document.querySelector("#tw_form_tracker");

  const $fileSizeNode = $form.querySelector(".upload-file-size");
  const $fileNameNode = $form.querySelector(".upload-file-name");
  const $uploadFileNode = $form.querySelector(".upload-text");
  const $numPagesNode = $tracker.querySelector(".final-quantity");
  const $priceNode = $tracker.querySelector(".final-price");

  $fileSizeNode.innerHTML = fileSizeText ?? "";
  $fileNameNode.innerHTML = fileNameText ?? "";
  $uploadFileNode.innerHTML = uploadText ?? "";
  $numPagesNode.innerHTML = priceText ?? "";
  $priceNode.innerHTML = numPagesText ?? "";
}
